import { PodcastInstanceStatus } from '@lib/network/podcasts';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import css from './PodcastStatusChip.module.scss';

export const PODCAST_STATUS_LABELS: Record<PodcastInstanceStatus, string> = {
  queued: 'Queued',
  pending: 'Creating',
  completed: 'Completed',
  'partially-completed': 'Partially completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

/**
 * Small pill rendering a podcast project's status. `completed` collapses
 * to a green check icon — the listing has plenty of completed items, so
 * the visual noise of a label on each one isn't worth it.
 */
export const PodcastStatusChip = ({ status }: { status: PodcastInstanceStatus }) => {
  if (status === 'completed') {
    return <CheckCircleRoundedIcon className={css.completedIcon} aria-label="Completed" />;
  }
  return (
    <span className={`${css.chip} ${css[status]}`} aria-label={PODCAST_STATUS_LABELS[status]}>
      {PODCAST_STATUS_LABELS[status]}
    </span>
  );
};
